import { acPanelContacts, toggleAcPanelBranch, toggleAcPanelMain } from "@/lib/ac-panel-controls";
import { useT } from "@/lib/i18n";
import { useSystemStore } from "@/lib/store";
import type { ComponentDefinition } from "@/lib/types";

export function AcPanelSwitches({ nodeId, def }: { nodeId: string; def: ComponentDefinition }) {
  const tr = useT();
  const state = useSystemStore(s => s.simulateState.componentStates[nodeId]);
  const setState = useSystemStore(s => s.setComponentSimulateState);
  const contacts = acPanelContacts(def, state);
  const button = (label: string, on: boolean | undefined, action: () => void, disabled = false) => <button
    type="button" aria-label={label} aria-pressed={on} disabled={disabled} onClick={action}
    className="rounded border border-[var(--color-border)] px-2 py-1 text-[11px] disabled:opacity-50"
    style={{ background: on ? "var(--color-accent-soft)" : "var(--color-surface)", color: "var(--color-fg)" }}>
    {label} <span className="font-medium">{tr(on == null ? "simulate.ac.unknown_label" : on ? "simulate.ac.on_label" : "simulate.ac.off_label")}</span>
  </button>;
  return <div className="nodrag nopan pointer-events-auto mt-2 space-y-1.5 text-center"
    onPointerDown={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()} onClick={e => e.stopPropagation()}>
    {button(tr("simulate.ac.main"), contacts.main, () => setState(nodeId, toggleAcPanelMain(def, state)))}
    <div className="flex flex-wrap justify-center gap-1">
      {contacts.branches.map((on, i) => <span key={i}>
        {button(tr("simulate.ac.branch", { number: i + 1 }), on,
          () => setState(nodeId, toggleAcPanelBranch(def, state, i + 1)), !contacts.main)}
      </span>)}
    </div>
  </div>;
}
